import type { FetchConfig } from '@nlo/nuxt-common/api/helper-types';
import type { paths } from '~/generated/portal-api';

export function createKioskApi(fetchConfig: FetchConfig) {
	const client = fetchConfig.createClient<paths>();

	return {
		getIdinUrl(issuerId: string, basketId: string) {
			return client.POST('/api/kiosk/age-validation/idin', { body: { issuerId, basketId } });
		},
	};
}
